// extracted by mini-css-extract-plugin
module.exports = {"approval":"approval_approval__9PNNR","approval_text":"approval_approval_text__harF7","approval_list":"approval_approval_list__INOXy"};